<form>
  <ng-container *transloco="let t; read: 'ime.common.properties'">
    <div class="form-group row">
      <label for="code" class="col-sm-4 col-form-label">{{t('Code')}}</label>
      <div class="col-sm-8">
        <input type="text" class="form-control" id="code" name="code" [(ngModel)]="property.Code">
      </div>
    </div>
    <div class="form-group row">
      <label for="name" class="col-sm-4 col-form-label">{{t('Name')}}</label>
      <div class="col-sm-8">
        <input type="text" class="form-control" id="name" name="name" [(ngModel)]="property.Name">
      </div>
    </div>
    <div class="form-group row">
      <label for="type" class="col-sm-4 col-form-label">{{t('Type')}}</label>
      <div class="col-sm-8">
        <mes-web-classificator-value-select [entityId]="property.TypeClv" (entityIdChange)="property.TypeClv = $event" name="type" id="type" [items$]="classificatorValueService.propertyTypes$" [allowAdd]="false"></mes-web-classificator-value-select>
      </div>
    </div>
    <div class="form-group row" *ngIf="property.isChoice()">
      <label for="choiceType" class="col-sm-4 col-form-label">{{t('Choice Type')}}</label>
      <div class="col-sm-8">
        <mes-web-classificator-select [entityId]="property.ChoiceTypeClassificatorId" (entityIdChange)="property.ChoiceTypeClassificatorId = $event" name="choiceType" id="choiceType" [items$]="classificatorsQuery.selectAll()"></mes-web-classificator-select>
      </div>
    </div>
    <div class="form-group row" *ngIf="property.isChoice() || property.isNumeric() || property.isFileLink()">
      <label for="multiValue" class="col-sm-4 col-form-label">{{t('Multi value')}}</label>
      <div class="col-sm-8 my-auto">
        <div class="form-check">
          <input type="checkbox" class="form-check-input position-static" [(ngModel)]="property.IsMultiValue" name="multiValue" id="multiValue">
        </div>
      </div>
    </div>
    <div class="form-group row" *ngIf="property.isChoice() || property.isNumeric()">
      <label for="unit" class="col-sm-4 col-form-label">{{t('Unit')}}</label>
      <div class="col-sm-8">
        <mes-web-unit-select [entityId]="property.UnitId" (entityIdChange)="property.UnitId = $event" name="unit" id="unit" [items$]="unitService.getAll$"></mes-web-unit-select>
      </div>
    </div>
    <div class="form-group row" *ngIf="property.isNumeric() || property.isDateTime() || property.isText()">
      <label for="RoundingFactor" class="col-sm-4 col-form-label">{{t('RoundingFactor')}}</label>
      <div class="col-sm-8">
        <input type="number" class="form-control" id="RoundingFactor" name="RoundingFactor" [(ngModel)]="property.RoundingFactor">
        <small id="RoundingFactorHelp" class="form-text text-muted" *ngIf="property.isNumeric() && property.RoundingFactor != null">Example value: {{getPow(property.RoundingFactor)}}</small>
      </div>
    </div>
    <div class="form-group row">
      <label for="Sequence" class="col-sm-4 col-form-label">{{t('Sequence')}}</label>
      <div class="col-sm-8">
        <input type="number" class="form-control" id="Sequence" name="Sequence" [(ngModel)]="property.Sequence">
      </div>
    </div>
    <div class="form-group row">
      <label for="group" class="col-sm-4 col-form-label">{{t('Group')}}</label>
      <div class="col-sm-8">
        <mes-web-classificator-value-select [entityId]="property.GroupClv" (entityIdChange)="property.GroupClv = $event" name="group" id="group" [items$]="classificatorValueService.propertyGroups$"></mes-web-classificator-value-select>
      </div>
    </div>
  </ng-container>
</form>

